import { ref } from "vue";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { logException } from "@sazka/utils/logger/use-app-logger";
import { mountComponent } from "@sazka/utils/mount-helper";

const isMounted = ref(false);
const mountPromise = ref<Promise<any> | null>(null);

/**
 * Hook to mount the logout component with optional loader handling.
 * @param useLoader - Whether to show the DS overlay loader during the mounting process.
 */
export const useMountLogout = async (useLoader = true): Promise<void> => {
    if (isMounted.value) return;

    try {
        const importFn = () => import("../user-logout.vue");

        if (useLoader) Loader.show();
        mountPromise.value = mountComponent("auth-logout", importFn);
        await mountPromise.value;

        isMounted.value = true;
    } catch (e) {
        logException("Failed to mount logout component", {
            error: e,
            useLoader,
        });
    } finally {
        if (useLoader) Loader.hide();
    }
};
